import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { CampaignFilters } from '../models/campaign-filters.model';

export const getCampaignsTotalCount: AsyncThunk<
  number,
  Partial<CampaignFilters> | undefined,
  Record<string, unknown>
> = withMandant<Partial<CampaignFilters> | undefined, number>(
  Endpoints.CAMPAIGN_TOTAL_COUNT,
  'campaigns/get-campaigns-total-count',

  async ({ args, endpoint }) => {
    const queryParams = createQueryParams({
      name: args?.name,
      brandId: args?.brandId,
      modelIds: args?.modelIds,
      status: args?.status,
    });

    const { data }: AxiosResponse<number> = await axiosInstance.get(
      endpoint + queryParams
    );

    return data;
  }
);
